// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__I1Ey8","button":"Button_button__vjwRP","outline":"Button_outline__qBUUH"};